import React, { useState } from "react";
import { Footer } from "../components";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { siginAdmin } from "../utils/Api/ApiCalls";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ClipLoader from "react-spinners/ClipLoader";
import { useRecoilState } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import FontAwesome icons
// import ArgoneLogo from "../../../public/assets/imgs/theme/logo.svg";
import ArgoneLogo from "../logo.svg";

const UserLogin = () => {
  const Navigate = useNavigate();
  const [user, setUser] = useRecoilState(userState);

  const [checkedBox, setCheckBox] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility

  const [loading, setLoading] = useState(false);
  const schema = yup.object().shape({
    email: yup.string().email().required("email is required"),
    password: yup.string().required("password is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const loginAdmin = handleSubmit(async (data) => {
    setLoading(true);
    try {
      const res = await siginAdmin(data);
      console.log('Login Response:', res); // Debug: Check the response structure
      
      setLoading(false);
      
      if (!res.data) {
        Swal.fire({
          icon: "error",
          title: res.message || "An error occurred",
          timer: 3000,
          showConfirmButton: false,
        });
      } else {
        // Set user state (this will be persisted by recoil-persist to localStorage)
        setUser(res);
        console.log('User data saved to Recoil state:', res); // Debug: Verify user state
        console.log('Token:', res.data.token); // Debug: Verify token exists
        
        Swal.fire({
          icon: "success",
          title: "Login Successful",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          Navigate("/admin-dashboard");
          window.location.reload();
        });
        reset();
      }
    } catch (err) {
      console.error('Login Error:', err); // Debug: Check error details
      Swal.fire({
        icon: "error",
        title: err.response?.data?.message || "An error occurred",
        timer: 3000,
        showConfirmButton: false,
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  });

  const onChecked = () => {
    setCheckBox(!checkedBox);
  };
  return (
    <>
      <section class="content-main mt-80 pb-0">
        <div class="card mx-auto card-login">
          <div class="card-body">
            <p>
              <img src={ArgoneLogo} alt="Argone-logo" />
            </p>
            <h4 class="card-title mb-4">Sign in</h4>
            <form onSubmit={loginAdmin}>
              <div class="mb-3">
                <input
                  {...register("email")}
                  class="form-control"
                  placeholder="Email"
                  type="text"
                />
                <p style={{ color: "red" }}>{errors?.email?.message}</p>
              </div>

              {/* <div class="mb-3"> */}
              <div className="input-group">
                <input
                  {...register("password")}
                  class="form-control"
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                />
                <span
                  className="input-group-text"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    cursor: "pointer",
                    border: "none",
                    backgroundColor: "#f4f5f9",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
                <p style={{ color: "red" }}>{errors?.password?.message}</p>
                {/* </div> */}
              </div>

              <div class="mb-3">
                <a href="/forgot-password" class="float-end font-sm text-muted">
                  Forgot password?
                </a>
                <label class="form-check">
                  <input
                    onClick={onChecked}
                    type="checkbox"
                    class="form-check-input"
                    checked={checkedBox}
                  />
                  <span class="form-check-label">Remember</span>
                </label>
              </div>
              {!loading ? (
                <div class="mb-4">
                  <button
                    type="submit"
                    class="btn btn-primary w-100"
                    style={{
                      display: "flex",
                      // justifyContent: "space-between",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    Login
                  </button>
                </div>
              ) : (
                <div class="mb-4">
                  <button disabled type="submit" class="btn btn-primary w-100">
                    <div
                      style={{
                        display: "flex",
                        // justifyContent: "space-between",
                        justifyContent: "center",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <div>Loading... </div>
                      <span>
                        <ClipLoader color="white" size={15} />
                      </span>
                    </div>
                  </button>
                </div>
              )}
            </form>
            {/* <p class="text-center mb-4">
              Don't have account? <a href="admin-registration">Sign up</a>
            </p> */}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default UserLogin;
